export const styles = {
  page: (theme) => ({
    minHeight: '92vh',
    padding: '28px clamp(16px, 5vw, 48px)',
    background: theme.colors.background,
  }),
  wrap: { maxWidth: 920, margin: '0 auto' },

  header: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 16,
    flexWrap: 'wrap',
    marginBottom: 22,
  },
  title: (theme) => ({ margin: 0, fontSize: 26, fontWeight: 700, color: theme.colors.text }),
  subtitle: (theme) => ({ margin: '6px 0 0', fontSize: 14, maxWidth: 560, color: theme.colors.text, opacity: 0.65 }),
  companyChips: { display: 'flex', flexDirection: 'column', gap: 8, alignItems: 'flex-end' },
  chip: (theme) => ({
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    fontSize: 12.5,
    fontWeight: 600,
    padding: '5px 12px',
    borderRadius: 20,
    background: theme.colors.backgroundSecondary,
    color: theme.colors.text,
    whiteSpace: 'nowrap',
  }),

  card: (theme) => ({
    borderRadius: 14,
    overflow: 'hidden',
    background: theme.colors.backgroundSecondary,
    boxShadow: '0 6px 24px rgba(0,0,0,0.06)',
  }),
  cardHeader: { display: 'flex', alignItems: 'center', gap: 14, padding: '18px 20px' },
  iconCircle: (connected) => ({
    width: 48,
    height: 48,
    borderRadius: 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    flexShrink: 0,
    background: connected ? '#25D366' : '#8a94a6',
  }),
  cardTitle: (theme) => ({
    fontSize: 16,
    fontWeight: 600,
    color: theme.colors.text,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  }),
  cardMeta: (theme) => ({ fontSize: 13, color: theme.colors.text, opacity: 0.6 }),
  cardBody: { padding: 20, display: 'flex', flexDirection: 'column', gap: 18 },

  infoGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 12 },
  infoItem: (theme) => ({ padding: '12px 14px', borderRadius: 10, background: theme.colors.background }),
  infoLabel: (theme) => ({
    fontSize: 11,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    color: theme.colors.text,
    opacity: 0.5,
    marginBottom: 4,
  }),
  infoValueRow: { display: 'flex', alignItems: 'center', gap: 8 },
  infoValue: (theme) => ({
    fontSize: 14,
    fontWeight: 600,
    color: theme.colors.text,
    wordBreak: 'break-all',
    lineHeight: 1.3,
  }),

  hintRow: (theme) => ({
    padding: '10px 14px',
    borderRadius: 10,
    fontSize: 12.5,
    color: theme.colors.text,
    opacity: 0.65,
    background: theme.colors.background,
  }),
  actions: { display: 'flex', gap: 10, flexWrap: 'wrap' },

  emptyState: {
    padding: '36px 24px 40px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    gap: 14,
  },
  emptyIcon: (theme) => ({
    width: 64,
    height: 64,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.colors.primary,
    background: `${theme.colors.primary}18`,
  }),
  emptyTitle: (theme) => ({ fontSize: 18, fontWeight: 700, color: theme.colors.text }),
  emptyText: (theme) => ({ margin: 0, maxWidth: 440, fontSize: 14, lineHeight: 1.5, color: theme.colors.text, opacity: 0.7 }),

  sectionLabel: (theme) => ({
    margin: '26px 0 12px',
    fontSize: 13,
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: 0.6,
    color: theme.colors.text,
    opacity: 0.55,
  }),
  steps: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 14 },
  stepCard: (theme) => ({
    borderRadius: 12,
    padding: 18,
    background: theme.colors.backgroundSecondary,
    boxShadow: '0 4px 16px rgba(0,0,0,0.04)',
  }),
  stepIcon: (theme) => ({
    width: 40,
    height: 40,
    borderRadius: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 10,
    color: theme.colors.primary,
    background: `${theme.colors.primary}14`,
  }),
  stepTitle: (theme) => ({ fontSize: 15, fontWeight: 600, color: theme.colors.text, marginBottom: 4 }),
  stepText: (theme) => ({ fontSize: 13, lineHeight: 1.45, color: theme.colors.text, opacity: 0.65 }),
};
